import React from 'react';
import PageLayout from '../components/PageLayout';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiScissors, FiDownload, FiFileText, FiPrinter, FiGrid } = FiIcons;

const Printables = () => {
  const worksheets = [
    {
      id: 'cut-paste-pronouns',
      title: 'Cut & Paste Pronouns',
      desc: 'Match the Amharic pronouns to the correct pictures.',
      type: 'Cut & Paste',
      pages: 2,
      color: 'bg-green-100 text-green-700'
    },
    {
      id: 'family-tree',
      title: 'My Family Tree',
      desc: 'Fill in the blanks and paste family member titles.',
      type: 'Activity',
      pages: 1,
      color: 'bg-blue-100 text-blue-700'
    },
    {
      id: 'respect-sorting',
      title: 'Respect Sorting Hat',
      desc: 'Sort phrases into "Formal" and "Casual" baskets.',
      type: 'Sorting',
      pages: 3,
      color: 'bg-purple-100 text-purple-700'
    },
    {
      id: 'word-builder',
      title: 'Amharic Word Builder',
      desc: 'Cut out letters to build basic nouns like "Bet" and "Sew".',
      type: 'Spelling',
      pages: 4,
      color: 'bg-amber-100 text-amber-700'
    }
  ];

  const handleDownload = (title) => {
    alert(`Downloading ${title} PDF... (Simulation)`);
  };

  return (
    <PageLayout
      title="Printable Resources"
      subtitle="Classroom-ready worksheets designed for hands-on learning. Download, print, and create!"
      icon={FiScissors}
      color="text-amber-600"
      bgColor="bg-amber-50"
      prevLink="/teacher-hub"
      prevLabel="Teacher Hub"
    >
      <div className="fade-in">
        <div className="grid md:grid-cols-2 gap-6">
          {worksheets.map(sheet => (
            <div key={sheet.id} className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow flex flex-col md:flex-row gap-6">
              {/* Preview Placeholder */}
              <div className="w-full md:w-32 h-40 bg-gray-100 rounded-xl border-2 border-dashed border-gray-300 flex items-center justify-center flex-shrink-0">
                <SafeIcon icon={FiFileText} className="text-4xl text-gray-300" />
              </div>
              
              <div className="flex-1">
                <div className="flex items-start justify-between mb-2">
                  <span className={`px-2 py-1 rounded text-xs font-bold uppercase tracking-wide ${sheet.color}`}>
                    {sheet.type}
                  </span>
                  <span className="text-xs text-gray-500 font-medium">{sheet.pages} Pages</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-800 mb-2">{sheet.title}</h3>
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">{sheet.desc}</p>
                
                <div className="flex gap-3">
                  <button 
                    onClick={() => handleDownload(sheet.title)}
                    className="flex-1 py-2 bg-gray-900 text-white rounded-lg font-bold text-sm hover:bg-gray-800 transition-colors flex items-center justify-center gap-2"
                  >
                    <SafeIcon icon={FiDownload} /> PDF
                  </button>
                   <button 
                    onClick={() => window.print()}
                    className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                    title="Quick Print"
                  >
                    <SafeIcon icon={FiPrinter} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Info Box */}
        <div className="mt-8 bg-amber-50 rounded-2xl p-6 border border-amber-100 flex items-start gap-4">
          <div className="p-3 bg-amber-100 rounded-full text-amber-600">
             <SafeIcon icon={FiGrid} className="text-xl" />
          </div>
          <div>
            <h4 className="font-bold text-amber-900 mb-1">Teacher's Note</h4>
            <p className="text-amber-800 text-sm">
              These materials are designed to be printed on standard A4 or Letter paper. For the "Cut & Paste" activities, we recommend having child-safe scissors and glue sticks ready.
            </p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Printables;